export default {
	tabs: {
		user: "Impostazioni utente",
		customer: "Conto cliente",
		delivery: "Indirizzi di consegna",
		invoice: "Indirizzi di fatturazione",
	},
};
